module.exports = __webpack_public_path__ + "img/bg-feedback.jpg?f6057ade4483cbc709d2edf51122e823";